import BadgesComponent from '@components/common/Badges';
import Button from '@components/common/Button';
import endpoints from '@config/endpoints';
import { getData, getDataWithCache, postDataJSON } from '@services/CommonApiService';
import { PagePermission } from '@services/usePermission';
import { setAncPregBackHandler, setIsFirstPregnancy, setPregnancyDetails, setPregnancyHistory, updateAncService, updateDeliveryDetails, updatePNC, } from '@store/actions/beneficiaryAction';
import { RootState } from '@store/reducers';
import FormatDate from '@utils/dateFormat';
import dayjs from 'dayjs';
import './index.css'
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import PlusSvgIcon from '../../../../assets/svg_main/plus.svg';
import AncServices from '../ANC/AncServices';
import CommonServiceInfoBar from '../CommonServiceInfoBar';
import PregnancyDetails from './PregnancyDetails';
import ClosePregnancy from '../PregnancyClosure';
import { errorLogger } from '@utils/applicationLogUtils';
import { PNC_COMMON_CONSTANTS } from '../PNC/PNCConstants';
import { COMMON_CONSTANTS, dateFormate } from '@constants/index';
import { buttonNames } from '@constants/appConstants';
import PregnancyActionButtons from './PregnancyActionButtons';
import { benef_const, benef_life_calendar_const } from '@constants/beneficiaryConstant';
import { Modal } from 'react-bootstrap';
import { set } from 'lodash';
import { toast } from 'react-toastify';
import { error } from '@constants/ancConstants';
import {decodeWithKeyAndShift, encodeWithKeyAndShift } from '@utils/base64Utils';

const PregnancyServices: React.FC<any> = ({ isPregnancyClosed, handleshowAncModal, addPregnancyOnClick }: any) => {
    const canViewServices = PagePermission("Benf_Service", "Service_OVPg");
    const canCreateServices = PagePermission("Benf_Service", "Service_CrPg");

    const [isExpandAll, setIsExpandAll] = useState<boolean>(false);
    const [showANCModal, setShowANCModal] = useState<boolean>(false);
    const [showPregnancyClosureModal, setShowPregnancyClosureModal] = useState<boolean>(false);
    const [showReceivedModal, setShowReceivedModal] = useState<boolean>(false);
    const [showAddServiceButton, setShowAddServiceButton] = useState<boolean>(true);
    const [submitStatusButtonClicked, setSubmitStatusButtonClicked] = useState<boolean>(false);
    const [currentServiceItem, setCurrentServiceItem] = useState<any>([]);
    const [receivedStatus, setReceivedStatus] = useState<string>('');
    const [receivedData, setReceivedData] = useState<any>([]);
    const [receivedId, setReceivedId] = useState<string>('');
    const [serviceApiResponse, setServiceApiResponse] = useState<any>({});
    const [serviceList, setServiceList] = useState<any>([]);
    const pregnancyId = useSelector((state: RootState) => state.beneficiary.currPregnancyId);
    const ancPregBackObj = useSelector((state: RootState) => state.beneficiary.ancPregnancyBackhandler);
    const selectedAncService = useSelector((state: RootState) => state.beneficiary.selectedAncService);
    const viewPregnancyDetails = useSelector((state: RootState) => state.beneficiary.viewPregnancyDetails);
    const benfDetails = useSelector((state: RootState) => state.beneficiary.beneficiaryDetails);
    const pageMenuFromLifeCalendar = useSelector((state: RootState) => state.beneficiary.pageMenuFromLifeCalendar);
    const beneficiaryPregnancyHistoryFromStore = useSelector((state: RootState) => state.beneficiary.beneficiaryPregnancyHistory);
    const benefPregnancyDetails = useSelector((state: RootState) => state.beneficiary.pregnancyDetails);
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [pregancyReg, setPregnancyReg] = useState<any>();
    const [ancServiceItems, setAncServiceItems] = useState<any>();
    const [ancServiceData, setAncServiceData] = useState<any>();
    const userId = localStorage.getItem('userId');
    const isExpandable = benef_const.serviceBarExpandableCodes;
    const editableServices = ['delivery', 'delivery_preparedness'];
    const canEditServices = PagePermission("Benf_Service", "Service_EdPg");
    const userRole = benfDetails?.user_role || localStorage.getItem('userTypeName');
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        intialFetch();
        fetchServiceContent();

        return () => {
            dispatch(updateAncService('selectedAncService', []))
            dispatch(updateAncService('currentFacilityDetails', {}))
        };
    }, [beneficiaryPregnancyHistoryFromStore]);

    useEffect(() => {
        if (ancPregBackObj && pregnancyId) {
            refreshServiceList();
        }
    }, [ancPregBackObj]);

    useEffect(() => { }, [showAddServiceButton])
    useEffect(() => {
        handleServiceButtonEnable();
    }, [viewPregnancyDetails]);

    const handleServiceButtonEnable = () => {
        if (viewPregnancyDetails) {
            if (viewPregnancyDetails.lmp) {
                const initialDate = new Date(FormatDate(viewPregnancyDetails.lmp));
                initialDate.setDate(initialDate.getDate() + 31);
                const finalDate = new Date(initialDate);
                const currentDate = new Date();
                const timeDifference = currentDate.getTime() - finalDate.getTime();
                const dayDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));
                if (dayDifference < 0) {
                    setShowAddServiceButton(false)
                }
                else {
                    setShowAddServiceButton(true)
                }
            }
        }
    }

    const intialFetch = async () => {
        try {
            setLoading(true);
            let pregnancyId;
            let pregnancyDetails: any;
            let pregnancyRegDetails: any;
            if (pageMenuFromLifeCalendar?.isNavigateFromLifeEvent && !pageMenuFromLifeCalendar.currentServices && (pageMenuFromLifeCalendar.naviGationType === benef_life_calendar_const.pregnancyStatus.abortion || pageMenuFromLifeCalendar.naviGationType === benef_life_calendar_const.pregnancyStatus.still_birth || pageMenuFromLifeCalendar.naviGationType === benef_life_calendar_const.pregnancyStatus.success)) {
            pregnancyId = pageMenuFromLifeCalendar?.pregnancyId;
            } else {
            pregnancyDetails = await beneficiaryPregnancyHistoryFromStore;
            pregnancyId = ancPregBackObj?.pregnancyId || pregnancyDetails?.data?.[0]?.pregnancy_id;
        }
            if (pregnancyId) {
                const cachedPregnancyMatches = benefPregnancyDetails?.pregnancyId === pregnancyId && benefPregnancyDetails?.data?.length > 0;
                pregnancyRegDetails = cachedPregnancyMatches ? benefPregnancyDetails : await getData(`${endpoints.getPregnancyDetailsById}/${pregnancyId}`);
                if (!cachedPregnancyMatches) {
                    dispatch(
                        setPregnancyDetails({
                        ...pregnancyRegDetails,
                        pregnancyId,
                        }),
                    );
                }
                const lmpDate = dayjs(pregnancyRegDetails?.data?.[0]?.lmp).isValid() ? pregnancyRegDetails?.data?.[0]?.lmp : dayjs();
                const formattedLmpDate = FormatDate(lmpDate);
                const isPregnancyUpdated = !cachedPregnancyMatches;
                const serviceList: any = ancPregBackObj
                    ? await getData(`${endpoints.getServiceListByPregnancyId}/${pregnancyId}/${formattedLmpDate}`)
                    : await getDataWithCache(`${endpoints.getServiceListByPregnancyId}/${pregnancyId}/${formattedLmpDate}`);
                dispatch(updateAncService("pregnancyServices", serviceList?.data));
                setServiceList(serviceList?.data);
            }
            const isFirstPregnancy = pregnancyDetails?.data?.length === 1 && pregnancyRegDetails?.data[0]?.is_first_preg
            dispatch(setIsFirstPregnancy(isFirstPregnancy));
            setPregnancyReg(pregnancyRegDetails?.data);
            dispatch(setPregnancyHistory(pregnancyDetails?.data));
            dispatch(updateAncService("currPregnancyId", pregnancyId));
            dispatch(updateAncService("pregHistoryDetails", pregnancyDetails?.data?.[0]));
            dispatch(updateAncService("currLmpDate", pregnancyRegDetails?.data?.[0]?.lmp));
            dispatch(updateAncService("serviceExists", pregnancyRegDetails?.data?.[0]?.service_exists));
            dispatch(updateAncService("viewPregnancyDetails", pregnancyRegDetails?.data[0]));
            dispatch(updateAncService("moduleCode", pregnancyDetails?.data?.[0]?.module_code));

            if (ancPregBackObj) {
                (ancPregBackObj?.ancListItemIdx || serviceList?.data || ancPregBackObj.ancNo) && handleToggleChanges(ancPregBackObj?.ancListItemIdx, serviceList?.data, ancPregBackObj.ancNo, pregnancyId);
                ancPregBackObj?.isExpandAll && handleExpandAll(ancPregBackObj?.isExpandAll, serviceList?.data, pregnancyId);
                dispatch(setAncPregBackHandler(null));
            }
            const getANCStatusData = await getDataWithCache(endpoints.getANCStatusId);
            setReceivedData(getANCStatusData?.data);
        } catch (error: any) {
            errorLogger(error?.response?.data || error?.response || error)
        } finally {
            setLoading(false);
        }
    }

    const refreshServiceList = async () => {
        try {
            if (!pregnancyId) return;
            
            const cachedPregnancyMatches = benefPregnancyDetails?.pregnancyId === pregnancyId && benefPregnancyDetails?.data?.length > 0;
            const pregnancyRegDetails: any = cachedPregnancyMatches ? benefPregnancyDetails : await getData(`${endpoints.getPregnancyDetailsById}/${pregnancyId}`);
            if (!cachedPregnancyMatches) {
                dispatch(
                    setPregnancyDetails({
                    ...pregnancyRegDetails,
                    pregnancyId,
                    }),
                );
            }
            const lmpDate = dayjs(pregnancyRegDetails?.data?.[0]?.lmp).isValid() ? pregnancyRegDetails?.data?.[0]?.lmp : dayjs();
            const formattedLmpDate = FormatDate(lmpDate);
            const isPregnancyUpdated = !cachedPregnancyMatches;
            const serviceList: any = ancPregBackObj 
                ? await getData(`${endpoints.getServiceListByPregnancyId}/${pregnancyId}/${formattedLmpDate}`)
                : await getDataWithCache(`${endpoints.getServiceListByPregnancyId}/${pregnancyId}/${formattedLmpDate}`);            
            dispatch(updateAncService("pregnancyServices", serviceList?.data));
            setServiceList(serviceList?.data);
        } catch (error: any) {
            errorLogger(error?.response?.data || error?.response || error);
        }
    };

    useEffect(()=>{
        const fetchServiceData=async ()=>{
            if (pregnancyId && submitStatusButtonClicked) {
                const cachedPregnancyMatches = benefPregnancyDetails?.pregnancyId === pregnancyId && benefPregnancyDetails?.data?.length > 0;
                const pregnancyRegDetails: any = cachedPregnancyMatches ? benefPregnancyDetails
                    : await getData(`${endpoints.getPregnancyDetailsById}/${pregnancyId}`);
                if (!cachedPregnancyMatches) {
                    dispatch(
                    setPregnancyDetails({
                    ...pregnancyRegDetails,
                    pregnancyId,
                    }),
                    );
                }  
                const lmpDate = dayjs(pregnancyRegDetails?.data?.[0]?.lmp).isValid() ? pregnancyRegDetails?.data?.[0]?.lmp : dayjs();
                const formattedLmpDate = FormatDate(lmpDate);
                const serviceList: any = await getDataWithCache(`${endpoints.getServiceListByPregnancyId}/${pregnancyId}/${formattedLmpDate}`);
                dispatch(updateAncService("pregnancyServices", serviceList?.data));
                setServiceList(serviceList?.data);
                const getANCStatusData = await getDataWithCache(endpoints.getANCStatusId);
                setReceivedData(getANCStatusData?.data);
            }
        }
        fetchServiceData();
    },[submitStatusButtonClicked])

    const onClickAncServices = () => {
        setShowANCModal(true);
    }
    const onClickCLosePregnancy = () => {
        setShowPregnancyClosureModal(true);
    }
    const storeUserId = localStorage.getItem('userId');
    const serviceCategoryFalseOptions = localStorage.getItem('serviceCategoryFalseOptions');
    const fetchServiceContent = async () => {
        let serviceContent: any = [];
        let serviceResponseData: any = {};
        try {
            if(storeUserId && serviceCategoryFalseOptions) {
                serviceResponseData = JSON.parse(decodeWithKeyAndShift(serviceCategoryFalseOptions));
                serviceContent = serviceResponseData?.data?.map((item: any) => item?.service_category_name);
            }
            else{
                serviceResponseData = await getDataWithCache<any>(`${endpoints.getServiceCategory}/false`);
                serviceContent = await serviceResponseData?.data?.map((item: any) => item?.service_category_name);
                localStorage.setItem('serviceCategoryFalseOptions', encodeWithKeyAndShift(JSON.stringify(serviceResponseData)));
            }
            setAncServiceItems(serviceContent);
            setAncServiceData(serviceResponseData);
            return serviceContent;
        } catch (error: any) {
            errorLogger(error?.response?.data || error?.response || error)
        }
    };

    const serviceContent = {
        title: 'Add Services',
        subTitle: 'Services',
        content: ancServiceItems || [],
        data: ancServiceData,
    };

    const handleToggleChanges = (index: number, serviceList: any, serviceName: any, pregnancyId: any) => {
        let ancNo;
        if (Number(serviceName)) {
            ancNo = serviceName;
        } else {
            ancNo = serviceName?.match(/\d+/) ? serviceName?.match(/\d+/)[0] : 0;
        }


        const periodName = serviceList[index]?.service_period_name;
        const serviceCode = serviceList[index]?.service_category_code;
        const isCurrentlyExpanded = selectedAncService?.includes(periodName);
        // Call API only when opening and only if data is not already loaded.
        if (
            !isCurrentlyExpanded &&
            serviceApiResponse?.[periodName] === undefined
        ) {
            getServiceList(
                index,
                ancNo,
                periodName,
                serviceCode,
                pregnancyId,
                serviceList[index],
            );
        }

        const expandedService = isCurrentlyExpanded
            ? selectedAncService.filter((item: any) => item !== periodName)
            : [...selectedAncService, periodName];

        if (expandedService?.length !== serviceList?.length) {
            setIsExpandAll(false);
        } 
        else {
            setIsExpandAll(true);
        }
        if(serviceName.includes('ANC')){
            dispatch(updateAncService('canEditANCService', !hasAnyModuleCode(serviceList, benef_const.canEditANC)));
        }
        dispatch(updateAncService('selectedAncService', expandedService));
    }

    const hasAnyModuleCode = (
  items: any,
  codes:any
): boolean => {
  if (!Array.isArray(items) || !Array.isArray(codes) || codes.length === 0) return false;
  const set = new Set(codes.map(c => c.toLowerCase()));
  return items.some(it => {
    const code = (it?.module_code ?? '').trim().toLowerCase();
    return code !== '' && set.has(code);
  });
}

    const getServiceList = async (index: number, ancNo: number, periodName: string, serviceCode: any, pregnancyId: any,closedPregnancyData:any) => {
        try {
            let serviceList: any = { data: '' };
            switch (serviceCode) {
                case 'anc':
                    serviceList = await getData(
                        `${endpoints.getServiceSubCategoryListByPregnancyId(pregnancyId,ancNo)}`
                    );
                    break;
                case 'pnc_mother':
                    serviceList = await getDataWithCache(
                        `${endpoints.serviceSubCategoryListByPregnancyAndPNC}/${pregnancyId}/${ancNo}`
                    );
                    break;
                case 'abortion_care':
                    serviceList.data = [closedPregnancyData];
                    break;
                case 'delivery_details':
                    serviceList.data = [closedPregnancyData];
                    break;
                case 'delivery':
                    serviceList.data = [closedPregnancyData];
                    break;
            }

            setServiceApiResponse((prevState: any) => ({
                ...prevState,
                [periodName]: isEmptyObject(serviceList?.data) ? [] : serviceList?.data,
            }));
        } catch (error: any) {
            errorLogger(error?.response?.data || error?.response || error)
        }
    };

    const isEmptyObject = (obj: any) => {
        return obj ? Object.keys(obj).length === 0 : true;
    };

    const handleExpandAll = (isChecked: any, serviceList: any, pregnancyId: any) => {
        setIsExpandAll(isChecked);
        const expandableServices = serviceList.filter((item: any) => isExpandable.includes(item.service_category_code));
        const serviceNames = setAllServicesName(isChecked ? expandableServices : []);
        const ancMap = serviceNames.map((item: any) => item?.match(/\d+/) ? item?.match(/\d+/)[0] : 0);

        if (isChecked) {
            dispatch(updateAncService('canEditANCService', !hasAnyModuleCode(serviceList, benef_const.canEditANC)));
        }

        expandableServices?.forEach((service: any, index: number) => {
            const ancno = ancMap[index];
            const periodName = service.service_period_name;

            if (
                ancno &&
                serviceApiResponse?.[periodName] === undefined
            ) {
                getServiceList(
                    index,
                    ancno,
                    periodName,
                    service.service_category_code,
                    pregnancyId,
                    service,
                );
            }
        });
    }

    const setAllServicesName = (data: any) => {
        const servicesName = data?.map((item: any) => item.service_period_name);
        dispatch(updateAncService('selectedAncService', servicesName));
        return servicesName;
    }

    const handleViewClick = (item: any) => {
        const ancPregBackObj = {
            benfType: "female",
            menuItems: "Pregnancy Services",
        }
        dispatch(setAncPregBackHandler(ancPregBackObj));
        navigate(viewNavigationMap[item]);
    }
    const handleEditClick = (item: any) => {
        const ancPregBackObj = {
            benfType: "female",
            menuItems: "Pregnancy Services",
        }
        const editObj: any = {
            ancVisitDate: dayjs(item?.service_start_dt).format(dateFormate.yyyy_mm_dd),
            ancNo: 0,
            serviceSubCategoryId: '',
            serviceVisitId: '',
            isServiceTakenOutside: '',
        }
        dispatch(setAncPregBackHandler(ancPregBackObj));
        dispatch(updateDeliveryDetails('isEditButtonClicked', true));
        dispatch(updateAncService('viewEditMetaData', editObj));
        dispatch(updateAncService('serviceCtgryId', item?.service_category_id));
        dispatch(updateAncService('currServiceSubCtgryId', item?.service_subcategory_id || item?.service_category_id));
        navigate(editNavigationMap[item?.service_category_code]);
    }

    const viewNavigationMap: any = {
        'Pregnancy Registration': '/beneficiaries/service/overview/pregnancy-overview',
        'delivery': '/beneficiaries/service/overview/delivery-details',
        'delivery_preparedness': '/beneficiaries/service/overview/delivery-preparedness'
    };
    const editNavigationMap: any = {
        'delivery': '/beneficiaries/service/edit/delivery-details',
        'delivery_preparedness': '/beneficiaries/service/edit/delivery-preparedness'
    };

    const isLatestTakenService = (serviceDate: any) => {
        const takenEditableServices = serviceList?.filter((service: any) =>
            editableServices.includes(service.service_category_code) &&
            service.is_service_taken
        );

        if (!takenEditableServices || takenEditableServices.length === 0) return false;

        const latestDate = takenEditableServices.reduce((max: any, service: any) => {
            const date = dayjs(service.create_date);
            return date.isAfter(max) ? date : max;
        }, dayjs(takenEditableServices[0].create_date));

        return dayjs(serviceDate).isSame(latestDate, 'day');
    };

    const shouldShowEditButton = (name: any, serviceDate: any) => {

        const hasPNCMotherServices = serviceList?.some((service: any) => 
            service.service_category_code === PNC_COMMON_CONSTANTS.PNC_MOTHER
        );

        if (canEditServices && editableServices.includes(name)) {
            switch (name) {
                case 'delivery':
                case 'delivery_preparedness': {
                    if (hasPNCMotherServices) {
                        return false;
                    }
                    if (isLatestTakenService(serviceDate)) {
                        const daysSinceService = dayjs().diff(dayjs(serviceDate), 'day');
                        return daysSinceService <= 90;
                    }
                    break;
                }
                default:
                    return false;
            }
        }
        return false;
    };

    const getServiceDate = (item: any, option: string) => {
        switch (item?.service_category_code) {
            case 'delivery_preparedness':
                return validateDate(item?.service_start_dt);
            case 'delivery':
            case 'abortion_care':
                return validateDate(item?.service_end_dt);
            default: {
                if (option === 'start') {
                    return validateDate(item?.service_start_dt);
                } else if (option === 'end') {
                    return validateDate(item?.service_end_dt);
                } else {
                    return validateDate(item?.service_start_dt);
                }
            }
        }
    };

    const isEndDateNeeded = (item: any) => {
        switch (item?.service_category_code) {
            case 'anc':
                return true;
            case 'pnc_mother':
                return true;
            case 'pnc_child':
                return true;
            default:
                return false;
        }
    }

    const validateDate = (date: any) => {
        return date ? dayjs(date) : '';
    }
    const getStatus = (item: any) => {
        const currentDate = dayjs().startOf('day');
        const serviceEndDate = dayjs(item?.service_end_dt).startOf('day');
        switch (item?.service_category_code) {
            case 'delivery_preparedness':
                return currentDate.isBefore(serviceEndDate) ? 'Ongoing' : 'Completed';
            case 'delivery':
                return currentDate.isBefore(item?.service_start_dt) || currentDate.isSame(item?.service_start_dt) ? 'Ongoing' : 'Completed';
            default:
                return currentDate.isBefore(serviceEndDate) || currentDate.isSame(serviceEndDate) ? 'Ongoing' : 'Completed';
        }
    };

    const isClosePregnancyApplicable = () => {
        return serviceList?.some((item: any) => item.service_category_code === PNC_COMMON_CONSTANTS.PNC_MOTHER);
    }

    const getServiceName = (serviceName: any, moduleCode: any) => {

        if ((benef_const.pregnancyClosedServiceNames.includes(serviceName)) || serviceName === benef_const.deliveryServiceCode && moduleCode === PNC_COMMON_CONSTANTS.AUTO_CLOSURE_PREGNANCY) {
            return benef_const.pregnancyClosure;
        } else {
            return serviceName;
        }
    }

    const handleStatusUpdate = async (periodId: string) => {
        const payload = {
            servicePeriodId: periodId,
            serviceAvailedStatusId: receivedId,
            parentUserId: userId,
        }
        try {
            const res = await postDataJSON(endpoints.updateANCServiceStatus, payload);
            if (res.data) {
                toast.success(benef_const.ancStatusUpdateSuccessMessage, {
                    position: "top-center"
                });
                setShowReceivedModal(false);
                setSubmitStatusButtonClicked(true);
            }
            else {
                toast.error(error.errorMessage, {
                    position: "top-center"
                });
            }
        }
        catch (e) {
            toast.error(error.errorMessage, {
                position: "top-center"
            });
        }
    }

    const checkExpandable = (serviceCode: any, moduleCode: any) => {
        if (serviceCode === benef_const.deliveryCategoryCode && moduleCode === PNC_COMMON_CONSTANTS.AUTO_CLOSURE_PREGNANCY) {
            return true
        }
        else if (serviceCode === benef_const.deliveryCategoryCode && moduleCode !== PNC_COMMON_CONSTANTS.AUTO_CLOSURE_PREGNANCY) {
            return false
        }
        else return isExpandable.includes(serviceCode);

    }


    const isServiceMissed = (item: any) => {
        return (item.status === COMMON_CONSTANTS.MISSED && !item.is_service_taken) || (item.status === COMMON_CONSTANTS.RECEIVED && !item.is_service_taken);
    }

    const handleCheckFromLifeCalendar = () => {
        return (pageMenuFromLifeCalendar == null || (pageMenuFromLifeCalendar?.isNavigateFromLifeEvent && (pageMenuFromLifeCalendar?.currentServices || pageMenuFromLifeCalendar?.naviGationType === benef_life_calendar_const.pregnancyStatus.on_going)))
    }

    const pncMotherItems = serviceList?.filter((s: any) => s.service_category_code === 'pnc_mother' && s.create_date);
    const latestPNCMotherCreateDate = pncMotherItems?.length
        ? pncMotherItems.reduce((max: any, s: any) =>
            dayjs(s.create_date).isAfter(dayjs(max)) ? s.create_date : max,
            pncMotherItems[0].create_date
          )
        : null;

    const ancItems = serviceList?.filter((s: any) => s.service_category_code === 'anc' && s.create_date);
    const latestANCCreateDate = ancItems?.length
        ? ancItems.reduce((max: any, s: any) =>
            dayjs(s.create_date).isAfter(dayjs(max)) ? s.create_date : max,
            ancItems[0].create_date
          )
        : null;

    return (
        <>
            <div className='pregnancy-services-after-pregnancy'>
                <div className='pregnancy-header' >
                    <BadgesComponent
                        className="over-badge"
                        badgeName={"Pregnancy Services"}
                        variant="primary-1"
                        badgeType="case5"
                    />
                    {serviceList?.length > 0 && <div>
                        <label>{isExpandAll ? 'Close All' : 'Expand All'} &nbsp;
                            <input
                                type='checkbox'
                                onChange={(e) => handleExpandAll(e.target.checked, serviceList, pregnancyId)}
                                checked={isExpandAll} />
                        </label>
                    </div>}
                </div>
                {handleCheckFromLifeCalendar() && <>
                    {!isPregnancyClosed ? <div className='preg-close-buttons'>
                        <div>
                            {(!loading && userRole !== COMMON_CONSTANTS.FIELD_LEVEL_USER && showAddServiceButton && !isClosePregnancyApplicable()) &&
                                <Button
                                    onClick={onClickCLosePregnancy}
                                    buttonName={buttonNames.closePregnancyButton}
                                    colorType={'primary'}
                                    disabled={serviceList.find((item: any) => item.service_category_name === 'Delivery') || benfDetails?.[0]?.is_dead}
                                    id={'close-pregnancy-btn'}
                                    icon={''}
                                    iconPosition={'left'}
                                />
                            }
                        </div>
                        <div>
                            {(userRole !== COMMON_CONSTANTS.FIELD_LEVEL_USER && canCreateServices && showAddServiceButton) &&

                                <Button
                                    onClick={!benfDetails?.[0]?.is_dead ? onClickAncServices : () => { }}
                                    buttonName={buttonNames.addServicesButton}
                                    colorType={'primary'}
                                    disabled={benfDetails?.[0]?.is_dead}
                                    id={''}
                                    icon={<PlusSvgIcon />}
                                    iconPosition={'left'}
                                />}</div>
                    </div> : <PregnancyActionButtons
                        isDead={benfDetails?.[0]?.is_dead}
                        onAddServicesClick={() => {
                            handleshowAncModal();
                        }}
                        onAddPregnancyClick={() => {
                            addPregnancyOnClick();
                        }}
                        userRole={userRole}
                    />}
                </>}
                {showANCModal && <AncServices showModal={showANCModal} handleModalClose={() => setShowANCModal(false)} modalContent={serviceContent} />}
                {showPregnancyClosureModal && <ClosePregnancy showModal={showPregnancyClosureModal} handleModalClose={() => setShowPregnancyClosureModal(false)} />}
                {showReceivedModal && <div>
                    <Modal
                        show={showReceivedModal}
                        onHide={() => { }}
                        dialogClassName={'anc-service-modal'}
                        centered={true}
                        backdrop="static"
                    >
                        <Modal.Header>
                            <div style={{ display: "flex", justifyContent: "space-between", gap: "445px" }}>
                                <div className="d-flex align-items-center beneficiary_back_button" onClick={() => setShowReceivedModal(false)}>
                                    <i className="bi bi-arrow-left" style={{ cursor: "pointer" }} ></i>
                                    <span className="ms-1">Back</span>
                                </div>
                                <div className="d-flex align-items-center beneficiary_discard_button" onClick={() => setShowReceivedModal(false)}>
                                    <span className="me-0">Discard</span>
                                    <i className="bi bi-x" ></i>
                                </div>

                            </div>
                        </Modal.Header>
                        <Modal.Body  >
                            <div className="received-modal-body">
                                <span className={'option-heading-anc-service'}>
                                    {currentServiceItem.service_period_name}
                                    <span className={`radio_button_name ${'yes'}`}></span>
                                </span>
                                <div className="buttons">
                                    <div>
                                        <label htmlFor={'option1'} className='option-data'>
                                            <input
                                                className={'styled-radio'}
                                                type="radio"
                                                disabled={false}
                                                onChange={() => {
                                                    setReceivedStatus(benef_const.ancServiceReceived)
                                                    const id = receivedData.find((item: any) => item.service_availed_status_code === benef_const.ancServiceReceivedCode);
                                                    setReceivedId(id.service_availed_status_id)
                                                }}
                                                name={'ancReceivedOption'}
                                                value={receivedStatus}
                                                defaultChecked={receivedStatus === benef_const.ancServiceReceived ? true : false}
                                                id={''}
                                            />
                                            <span>{benef_const.ancServiceReceived}</span>
                                        </label>
                                    </div>
                                    <div>
                                        <label htmlFor={'option2'} className='option-data'>
                                            <input
                                                className={'styled-radio'}
                                                type="radio"
                                                disabled={false}
                                                onChange={() => {
                                                    setReceivedStatus(benef_const.ancServiceNotReceived)
                                                    const id = receivedData.find((item: any) => item.service_availed_status_code === benef_const.ancServiceNotReceivedCode);
                                                    setReceivedId(id.service_availed_status_id)
                                                }}
                                                name={'ancReceivedOption'}
                                                value={receivedStatus}
                                                defaultChecked={receivedStatus === benef_const.ancServiceNotReceived ? true : false}
                                                id={''}
                                            />
                                            {benef_const.ancServiceNotReceived}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="received-modal-submit">
                                <Button
                                    onClick={() => handleStatusUpdate(currentServiceItem.service_period_id)}
                                    disabled={receivedId ? false : true}
                                    id="received-anc-submit"
                                    buttonName={buttonNames.submit}
                                    colorType={'primary'}
                                    icon={''}
                                    iconPosition={''}
                                />
                            </div>
                        </Modal.Body>
                    </Modal>
                </div>
                }
            </div>
            <div style={{ width: '90%', marginTop: '20px' }}>
                {pregancyReg && !pregancyReg[0]?.is_pregnancy_registered_outside &&
                    pregancyReg?.map((item: any, index: any) => (
                        <CommonServiceInfoBar
                            key={index}
                            isViewIcon={true}
                            isEditIcon={false}
                            isExpand={false}
                            status={'Completed'}
                            isEndDateRequired={false}
                            startDate={item?.preg_reg_date}
                            onViewClick={() => handleViewClick('Pregnancy Registration')}
                            serviceName={'Pregnancy Registration'}
                        />
                    ))}
                {serviceList?.map((item: any, index: any) => (
                    <div className="pregnancy-registration-modal" key={item?.service_period_name} >
                        <CommonServiceInfoBar
                            isViewIcon={!isServiceMissed(item) && canViewServices && item.service_category_code!==benef_const.ancServiceCode }
                            isEditIcon={!isServiceMissed(item) && shouldShowEditButton(item?.service_category_code, item.create_date) && !benfDetails?.[0]?.is_dead}
                            isExpand={!isServiceMissed(item) && checkExpandable(item.service_category_code, item.module_code)}
                            status={(item.status)}
                            onAddClick={async () => {
                                setShowReceivedModal(true)
                                setCurrentServiceItem(item)
                                setReceivedId('');
                                setReceivedStatus('');
                                setSubmitStatusButtonClicked(false)
                                const getANCStatusData = await getDataWithCache(endpoints.getANCStatusId);
                                setReceivedData(getANCStatusData?.data);
                            }}
                            isAddIcon={!item.is_service_taken && !item.service_availed_status_name && item.service_category_code===benef_const.ancServiceCode && item.status !== 'Ongoing' && !benfDetails?.[0]?.is_dead}
                            isEndDateRequired={isEndDateNeeded(item)}
                            startDate={getServiceDate(item, 'start')}
                            endDate={getServiceDate(item, 'end')}
                            type={'pregnancyService'}
                            onViewClick={() => handleViewClick(item?.service_category_code)}
                            onEditClick={!benfDetails?.[0]?.is_dead ? () => handleEditClick(item) : () => { }}
                            serviceName={getServiceName(item?.service_period_name, item?.module_code)}
                            onExpand={(data) => handleToggleChanges(index, serviceList, item?.service_period_name, pregnancyId)}
                            isExpanded={selectedAncService?.includes(item?.service_period_name) ? true : false}
                            isInfoRequired={!benef_const.serviceBarExpandableCodesForInfo.includes(item?.service_category_code) && item.module_code !== PNC_COMMON_CONSTANTS.AUTO_CLOSURE_PREGNANCY}
                            item={item}
                        />
                        {selectedAncService?.includes(item?.service_period_name) && (
                            <>
                                <PregnancyDetails 
                                    data={serviceApiResponse} 
                                    periodName={item?.service_period_name} 
                                    idx={index} 
                                    isExpandAll={isExpandAll} 
                                    hasDeliveryService={serviceList?.some((service: any) => service.service_category_code === 'delivery')}
                                    latestPNCMotherCreateDate={latestPNCMotherCreateDate}
                                    periodCreateDate={item?.create_date}
                                    latestANCCreateDate={latestANCCreateDate}
                                />
                            </>
                        )}
                    </div>
                ))}
            </div>
        </>
    )
}

export default PregnancyServices;